'use client'

import { ReactNode, useState } from "react"
import { faAngleDown, faAngleUp, faCheck } from "@fortawesome/pro-regular-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
// Strapi: One Column Content

import ReactMarkdown from "react-markdown"
import rehypeRaw from "rehype-raw"
import {ReasonsBenefitsProps} from "@/app/types/flexible-content.types";


interface SingularReason {
    reason: string
}

interface ReasonProps {
    colour: "purple" | "orange" | "green" | "red" | "darkorange" | "blue"
    title: string
    reasons?: Array<SingularReason>
    children?: ReactNode
}

function Reason(props:ReasonProps) {

    let backgroundColour = '';
    let textColour = '';
    let borderColour = '';

    const [showReason, setShowReason] = useState<Boolean>(false);


    switch (props.colour) {
        case "purple":
            backgroundColour = "bg-[#F8EEFF]";
            textColour = "text-[#A059D9]";
            borderColour = "border-2 lg:border-none border-[#E6D0F7]";
            break;
        case "orange":
            backgroundColour = "bg-[#FEF2D9]";
            textColour = "text-[#E39B0E]";
            borderColour = "border-2 lg:border-none border-[#F9E1B0]";
            break;
        case "green":
            backgroundColour = "bg-[#D0FBDB]";
            textColour = "text-[#188A4D]";
            borderColour = "border-2 lg:border-none border-[#AAE4CA]";
            break;
        case "red":
            backgroundColour = "bg-[#FFDFDD]";
            textColour = "text-[#F04C53]";
            borderColour = "border-2 lg:border-none border-[#FFDFDD]";
            break;
        case "darkorange":
            backgroundColour = "bg-[#FFE4D4]";
            textColour = "text-[#FF6644]";
            borderColour = "border-2 lg:border-none border-[#FFE4D4]";
            break;
        case "blue":
            backgroundColour = "bg-[#DEF6FD]";
            textColour = "text-[#21BCE8]";
            borderColour = "border-2 lg:border-none border-[#DEF6FD]";
            break;
        default:
            break;
    }

    return (
        <div className={`rounded-lg flex flex-col p-5 lg:p-8 text-left ${backgroundColour} ${borderColour}`}>
            <div className={`cursor-pointer lg:cursor-default text-lg lg:text-3xl font-bold flex items-start justify-start ${textColour}`} onClick={() => setShowReason(!showReason)}>
                {props.title}
                <span className="lg:hidden ml-auto">
                    <FontAwesomeIcon icon={showReason ? faAngleUp : faAngleDown} className={`${textColour} mt-1 ml-2 `} />
                </span>
            </div>
            <span className={`${showReason ? "lg:flex h-full flex-col" : "hidden flex-col lg:flex h-full"}`}>
                <div className="mt-6">
                    {props.children ? props.children : null}
                </div>
            </span>
        </div>
    )
}


export default function ReasonsBenefits(props: {data: ReasonsBenefitsProps}) {
    return (
        <>
             <section className="py-10 xl:py-16">
				<div className="container
                text-left lg:text-center">
                    {props.data.Title && (
                        <h2 className="text-4xl xl:text-5xl font-bold leading-10 lg:leading-8">{props.data.Title}</h2>
                    )}
                    <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 mt-12">
                        {props.data.ReasonBlock.map((reason, index: number) => (
                             <Reason
                                key={index}
                                colour={reason.ColourScheme}
                                title={reason.Title}
                            >
                                <ReactMarkdown
                                    // @ts-expect-error
                                    rehypePlugins={[rehypeRaw]}
                                    className="markdown"
                                    components={{
                                        li: ({children}) => (
                                            <li className="list-inside pl-8 relative mb-4 last:mb-0">
                                                <FontAwesomeIcon icon={faCheck} className={`absolute top-[3px] left-[5px]`} />
                                                {children}
                                            </li>
                                        )}}
                                >
                                    {reason.Content}
                                </ReactMarkdown>
                            </Reason>
                        ))}
                    </div>
				</div>
			</section>
        </>
    )
}
